import React from 'react';
import ReactDOM from 'react-dom';
import {Router} from 'react-router';
import {history} from './history/History';
import App from './App';
import {Provider} from 'react-redux'
import store from "./redux/Store";
import {formatNumberToPersian} from "./utils/Utility";
import 'react-calendar/dist/Calendar.css';

window.baseAPI = process.env.REACT_APP_API_URL;
// window.baseAPI = "http://192.168.1.6:8085";
window.baseFile = process.env.REACT_APP_FILE_URL;
window.sessionLoaded = false
window.userLogin = false
window.pushByHistory = false

window.months = [{title: "January", month: 1},
    {title: "February", month: 2},
    {title: "March", month: 3},
    {title: "April", month: 4},
    {title: "May", month: 5},
    {title: "June", month: 6},
    {title: "July", month: 7},
    {title: "August", month: 8},
    {title: "September", month: 9},
    {title: "September", month: 10},
    {title: "November", month: 11},
    {title: "December", month: 12}]

let days = []
for (let i = 1; i < 32; ++i) {
    days.push({title: formatNumberToPersian(i), day: i})
}
let years = []
for (let i = 2022; i >= 1900; --i) {
    years.push({title: formatNumberToPersian(i), year: i})
}
window.days = days
window.years = years

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <App/>

        </Router>
    </Provider>
    , document.getElementById('root'));
